import React, { Component, Fragment } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  User,
  Phone,
  ArrowRight,
} from "react-feather";
import { withRouter } from "react-router-dom";

import {
  auth,
  createAdminProfileDocument,
  firestore,
} from "../../firebase/firebase.utils";
import "./login.css";
import { CircleLoader } from "react-spinners";
export class LoginTabset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeShow: true,
      startDate: new Date(),
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerConfirmPassword: "",
      registerStatus: "",
      registerMobileNo: "",
      loader: false,
      showLoginPassword: false,
      showRegisterPassword: false,
      showRegisterConfirmPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  toggleVisibility = (field) => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };

  handleLoginSubmit = async (event) => {
    event.preventDefault();

    const { loginEmail, loginPassword } = this.state;
    this.setState({ loader: true });
    try {
      await auth.signInWithEmailAndPassword(loginEmail, loginPassword);
      this.setState({ loginEmail: "", loginPassword: "", loader: false });
    } catch (error) {
      this.setState({ loader: false });
      alert(error);
    }
  };

  handleRegisterSubmit = async (event) => {
    event.preventDefault();
    const {
      registerEmail,
      registerPassword,
      registerConfirmPassword,
      registerStatus,
      registerDisplayName,
      registerMobileNo,
    } = this.state;
    if (registerPassword !== registerConfirmPassword) {
      alert("passwords don't match");
      return;
    }

    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        registerEmail,
        registerPassword,
      );

      await createAdminProfileDocument(user, {
        name: registerDisplayName,
        status: registerStatus,
        mobileNo: registerMobileNo,
        adminId: user.uid,
      });

      this.setState({
        registerDisplayName: "",
        registerEmail: "",
        registerPassword: "",
        registerConfirmPassword: "",
        registerMobileNo: "",
      });
      this.props.history.push("/dashboard");
    } catch (error) {
      alert(error);
    }
  };

  render() {
    const {
      showLoginPassword,
      showRegisterPassword,
      showRegisterConfirmPassword,
    } = this.state;

    return (
      <div>
        <Fragment>
          <Tabs>
            <TabList className="alg-tablist">
              <Tab className="alg-tab">Login</Tab>
              {this.props.currentAdmin && (
                <Tab className="alg-tab">Register</Tab>
              )}
            </TabList>

            <TabPanel>
              <form
                className="alg-form"
                onSubmit={this.handleLoginSubmit}
              >
                <div className="alg-field">
                  <label htmlFor="loginEmail">Email address</label>
                  <div className="alg-input-row">
                    <Mail />
                    <input
                      required
                      name="loginEmail"
                      value={this.state.loginEmail}
                      onChange={this.handleChange}
                      type="email"
                      placeholder="you@algcargos.com"
                      id="loginEmail"
                    />
                  </div>
                </div>
                <div className="alg-field">
                  <label htmlFor="loginPassword">Password</label>
                  <div className="alg-input-row">
                    <Lock />
                    <input
                      required
                      name="loginPassword"
                      value={this.state.loginPassword}
                      onChange={this.handleChange}
                      type={showLoginPassword ? "text" : "password"}
                      placeholder="••••••••"
                      id="loginPassword"
                    />
                    <button
                      type="button"
                      className="alg-visibility-btn"
                      onClick={() => this.toggleVisibility("showLoginPassword")}
                      aria-label={
                        showLoginPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showLoginPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </div>

                <div className="alg-row-between">
                  <label className="alg-checkbox">
                    <input type="checkbox" id="chk-ani2" />
                    Keep me signed in
                  </label>
                  <a href="#" className="alg-link">
                    Forgot password?
                  </a>
                </div>

                <button
                  className="alg-submit"
                  type="submit"
                  disabled={this.state.loader}
                >
                  {!this.state.loader && (
                    <>
                      Access dashboard
                      <ArrowRight />
                    </>
                  )}
                  <CircleLoader
                    loading={this.state.loader}
                    color="#ffffff"
                    size={15}
                  />
                </button>
                <p className="alg-fineprint">
                  Access is limited to ALG staff and verified partners.
                </p>
              </form>
            </TabPanel>
            {this.props.currentAdmin && (
              <TabPanel>
                <form
                  className="alg-form"
                  onSubmit={this.handleRegisterSubmit}
                >
                  <div className="alg-field">
                    <label htmlFor="registerDisplayName">Full name</label>
                    <div className="alg-input-row">
                      <User />
                      <input
                        required
                        name="registerDisplayName"
                        value={this.state.registerDisplayName}
                        onChange={this.handleChange}
                        type="text"
                        placeholder="Full name"
                        id="registerDisplayName"
                      />
                    </div>
                  </div>
                  <div className="alg-field">
                    <label htmlFor="registerMobileNo">Mobile number</label>
                    <div className="alg-input-row">
                      <Phone />
                      <input
                        required
                        name="registerMobileNo"
                        value={this.state.registerMobileNo}
                        onChange={this.handleChange}
                        type="number"
                        placeholder="01XXXXXXXXX"
                        id="registerMobileNo"
                      />
                    </div>
                  </div>
                  <div className="alg-field">
                    <label htmlFor="registerEmail">Email address</label>
                    <div className="alg-input-row">
                      <Mail />
                      <input
                        required
                        name="registerEmail"
                        value={this.state.registerEmail}
                        onChange={this.handleChange}
                        type="email"
                        placeholder="you@algcargos.com"
                        id="registerEmail"
                      />
                    </div>
                  </div>
                  <div className="alg-field">
                    <label htmlFor="registerPassword">Password</label>
                    <div className="alg-input-row">
                      <Lock />
                      <input
                        required
                        name="registerPassword"
                        value={this.state.registerPassword}
                        onChange={this.handleChange}
                        type={showRegisterPassword ? "text" : "password"}
                        placeholder="••••••••"
                        id="registerPassword"
                      />
                      <button
                        type="button"
                        className="alg-visibility-btn"
                        onClick={() =>
                          this.toggleVisibility("showRegisterPassword")
                        }
                        aria-label={
                          showRegisterPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >
                        {showRegisterPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="alg-field">
                    <label htmlFor="registerConfirmPassword">
                      Confirm password
                    </label>
                    <div className="alg-input-row">
                      <Lock />
                      <input
                        required
                        name="registerConfirmPassword"
                        value={this.state.registerConfirmPassword}
                        onChange={this.handleChange}
                        type={showRegisterConfirmPassword ? "text" : "password"}
                        placeholder="••••••••"
                        id="registerConfirmPassword"
                      />
                      <button
                        type="button"
                        className="alg-visibility-btn"
                        onClick={() =>
                          this.toggleVisibility("showRegisterConfirmPassword")
                        }
                        aria-label={
                          showRegisterConfirmPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >
                        {showRegisterConfirmPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="alg-field">
                    <label htmlFor="registerStatus">Admin status</label>
                    <div className="alg-input-row">
                      <User />
                      <select
                        name="registerStatus"
                        value={this.state.registerStatus}
                        onChange={this.handleChange}
                        required
                        id="registerStatus"
                      >
                        <option value="">Select admin status</option>
                        <option value="Admin">Admin</option>
                        <option value="Accounts">Accounts</option>
                        <option value="Employee">Employee</option>
                        <option value="Officer">Officer</option>
                      </select>
                    </div>
                  </div>
                  <p className="alg-terms">
                    <label className="alg-checkbox">
                      <input
                        className="checkbox_animated"
                        id="chk-ani3"
                        type="checkbox"
                      />
                      I agree to the <a href="#">terms &amp; conditions</a>
                    </label>
                  </p>
                  <button className="alg-submit" type="submit">
                    Create account
                    <ArrowRight />
                  </button>
                </form>
              </TabPanel>
            )}
          </Tabs>
        </Fragment>
      </div>
    );
  }
}

export default withRouter(LoginTabset);
